import { render, staticRenderFns } from "./ManufacturingLogbookList.vue?vue&type=template&id=736fdf75"
import script from "./ManufacturingLogbookList.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbookList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports